var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],attrs:{"placeholder":"按 Ctrl + Enter 发送"},domProps:{"value":(_vm.content)},on:{"keyup":_vm.onKeyup,"input":function($event){if($event.target.composing){ return; }_vm.content=$event.target.value}}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33d7057a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/wsmock/components/textinput.vue
// module id = 422
// module chunks = 2